const articles = [
  {
    title: 'Improving the performance of the recursive Fibonacci implementation using closures in Javascript',
    intro: 'If you ever encountered yourself doing recursion, I’m sure you faced the Fibonacci sequence algorithm. In this article, we will develop a...',
    url: 'https://medium.com/@juandpr/improving-the-performance-of-the-recursive-fibonacci-implementation-using-closures-in-javascript-c6bffdd9e48f',
    date: 'October 2020'
  },
  {
    title: 'Creating your own simplified implementation of JSON.stringify()',
    intro: 'In this article, we are going to talk about how to create our own simplified version of this method, and learn how to improve it...',
    url: 'https://medium.com/@juandpr/creating-your-own-simplified-implementation-of-json-stringify-ed8e50b9144a',
    date: 'September 2020'
  },
  {
    title: 'A practical example of Javascript closures',
    intro: 'Closures are something that many companies would like you to know before working for them, therefore, chances are they’ll ask you...',
    url: 'https://medium.com/@juandpr/a-practical-example-of-javascript-closures-d41ce0a7207f',
    date: 'August 2020'
  },
  {
    title: 'Creating a precise countdown with Vanilla JS',
    intro: 'On a recent technical interview I had for a big tech company, in one of the steps of the process I was asked the following...',
    url: 'https://medium.com/@juandpr/creating-a-precise-countdown-with-vanilla-js-cdc44c0483fa',
    date: 'August 2020'
  }
];

export default articles;
